import { FINANCE } from "../../../utils/ServiceUtils";
import { ServiceBase } from "../ServiceBase";
import { IGetFinanceSettingsRequest } from "./requests/GetFinanceSettingsRequest";
import { IListCurrencyRateRequest } from "./requests/ListCurrencyRateRequest";
import { IListTransactionSharesRequest } from "./requests/ListTransactionSharesRequest";
import { GetFinanceSettingsResponse } from "./responses/GetFinanceSettingsResponse";
import { ListCurrencyRateResponse } from "./responses/ListCurrencyRateResponse";
import { ListTransactionSharesResponse } from "./responses/ListTransactionSharesResponse";
import { IListLinkedEntriesRequest } from "./requests/ListLinkedEntriesRequest";
import { ListLinkedEntriesResponse } from "./responses/ListLinkedEntriesResponse";
import { IListJournalRequest } from "./requests/ListJournalRequest";
import { ListJournalResponse } from "./responses/ListJournalResponse";

export interface IFinanceService {
    getFinanceSettings(
        request: IGetFinanceSettingsRequest
    ): Promise<GetFinanceSettingsResponse>;
    listCurrencyRate(
        request: IListCurrencyRateRequest
    ): Promise<ListCurrencyRateResponse>;
    listTransactionShares(
        request: IListTransactionSharesRequest
    ): Promise<ListTransactionSharesResponse>;
    listLinkedEntries(
        request: IListLinkedEntriesRequest
    ): Promise<ListLinkedEntriesResponse>;
    listJournal(request: IListJournalRequest): Promise<ListJournalResponse>;
}

export class FinanceService extends ServiceBase implements IFinanceService {
    public async getFinanceSettings(
        request: IGetFinanceSettingsRequest
    ): Promise<GetFinanceSettingsResponse> {
        let response: any = null;
        try {
            response = (
                await this.makeCall(
                    request.toXml(),
                    FINANCE.getFinanceSettings,
                    request.cancelSource
                )
            ).data;
            await this.updateCache(
                FINANCE.getFinanceSettings,
                request.toXml(),
                response
            );
        } catch (error: any) {
            response = await this.getFromCache(
                FINANCE.getFinanceSettings,
                request.toXml()
            );
        }

        var parsedResponse = super.sendResponse(response)
            .GetFinanceSettingsResponse as GetFinanceSettingsResponse;
        if (!super._checkErrors(parsedResponse)) {
        }
        return parsedResponse;
    }

    public async listCurrencyRate(
        request: IListCurrencyRateRequest
    ): Promise<ListCurrencyRateResponse> {
        let response: any = null;
        try {
            response = (
                await this.makeCall(
                    request.toXml(),
                    FINANCE.listCurrencyRate,
                    request.cancelSource
                )
            ).data;
            await this.updateCache(
                FINANCE.listCurrencyRate,
                request.toXml(),
                response
            );
        } catch (error: any) {
            response = await this.getFromCache(
                FINANCE.listCurrencyRate,
                request.toXml()
            );
        }

        var parsedResponse = super.sendResponse(response)
            .ListCurrencyRateResponse as ListCurrencyRateResponse;
        if (!super._checkErrors(parsedResponse)) {
        }
        return parsedResponse;
    }

    public async listTransactionShares(
        request: IListTransactionSharesRequest
    ): Promise<ListTransactionSharesResponse> {
        let response: any = null;
        try {
            response = (
                await this.makeCall(
                    request.toXml(),
                    FINANCE.listTransactionShares,
                    request.cancelSource
                )
            ).data;
            await this.updateCache(
                FINANCE.listTransactionShares,
                request.toXml(),
                response
            );
        } catch (error: any) {
            response = await this.getFromCache(
                FINANCE.listTransactionShares,
                request.toXml()
            );
        }

        var parsedResponse = super.sendResponse2(response, ["SHARE"])
            .ListTransactionSharesResponse as ListTransactionSharesResponse;
        if (!super._checkErrors(parsedResponse)) {
        }
        return parsedResponse;
    }

    public async listLinkedEntries(
        request: IListLinkedEntriesRequest
    ): Promise<ListLinkedEntriesResponse> {
        let response: any = null;
        try {
            response = (
                await this.makeCall(
                    request.toXml(),
                    FINANCE.listLinkedEntries,
                    request.cancelSource
                )
            ).data;
            await this.updateCache(
                FINANCE.listLinkedEntries,
                request.toXml(),
                response
            );
        } catch (error: any) {
            response = await this.getFromCache(
                FINANCE.listLinkedEntries,
                request.toXml()
            );
        }

        var parsedResponse = super.sendResponse2(response, [
            "ITEM",
            "SHARE",
            "ROW",
        ]).ListLinkedEntriesResponse as ListLinkedEntriesResponse;
        if (!super._checkErrors(parsedResponse)) {
        }
        return parsedResponse;
    }

    public async listJournal(
        request: IListJournalRequest
    ): Promise<ListJournalResponse> {
        let response: any = null;
        try {
            response = (
                await this.makeCall(
                    request.toXml(),
                    FINANCE.listJournal,
                    request.cancelSource
                )
            ).data;
            await this.updateCache(
                FINANCE.listJournal,
                request.toXml(),
                response
            );
        } catch (error: any) {
            response = await this.getFromCache(
                FINANCE.listJournal,
                request.toXml()
            );
        }

        var parsedResponse = super.sendResponse2(response, ["JOURNAL"])
            .ListJournalResponse as ListJournalResponse;
        if (!super._checkErrors(parsedResponse)) {
        }
        return parsedResponse;
    }
}
